/**
 * @generated SignedSource<<b15c5ed61af4b309fb10fe9f040e54cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserGroupInput = {
  displayName?: string | null | undefined;
  id: string;
  name?: string | null | undefined;
};
export type UpdateUserGroupMutation$variables = {
  input: UpdateUserGroupInput;
};
export type UpdateUserGroupMutation$data = {
  readonly updateUserGroup: {
    readonly userGroup: {
      readonly displayName: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly roleAssignmentPrincipal: any;
      readonly uuid: any;
    } | null | undefined;
  };
};
export type UpdateUserGroupMutation = {
  response: UpdateUserGroupMutation$data;
  variables: UpdateUserGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserGroupPayload",
    "kind": "LinkedField",
    "name": "updateUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserGroup",
        "kind": "LinkedField",
        "name": "userGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roleAssignmentPrincipal",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateUserGroupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateUserGroupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b4a356c53e557ecd5c1f8d666729ee6",
    "id": null,
    "metadata": {},
    "name": "UpdateUserGroupMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateUserGroupMutation(\n  $input: UpdateUserGroupInput!\n) {\n  updateUserGroup(input: $input) {\n    userGroup {\n      id\n      uuid\n      name\n      displayName\n      roleAssignmentPrincipal\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc910551ceaa9762bb67ce46dd3837b7";

export default node;
